import { asMultiStyleConfig } from '../../../../utils/theme';
import { getColor } from '../../../../theme-tools';
var parts = ['container', 'innerContainer', 'control', 'label'];
var baseStyle = _ref => {
  var {
    theme
  } = _ref;
  return {
    control: {
      alignSelf: 'flex-start',
      border: "1px solid ".concat(getColor(theme, 'blue.600')),
      _checked: {
        borderColor: 'blue.900',
        borderWidth: '5px'
      },
      _focus: {
        borderColor: 'blue.300',
        borderWidth: '2px',
        boxShadow: "0 0 3px 2px ".concat(getColor(theme, 'blue.500')),
        _checked: {
          borderWidth: '5px'
        }
      },
      _disabled: {
        borderColor: 'grey.800',
        _checked: {
          borderColor: 'grey.800'
        }
      }
    }
  };
};
var defaultProps = {
  size: 'md'
};
export var Radio = asMultiStyleConfig({
  parts,
  baseStyle,
  defaultProps
});